import React from 'react';
import './ProjectInfo.css';

const ProjectInfo = () => (
  <div className='rightContainer'>
    <div>
      <h1>Real Time Chat Application</h1>
      <h2>To use this app, enter your name and the room you want to enter</h2>
    </div>
  </div>
);

export default ProjectInfo;
